<index-grid *ngIf="router.url.indexOf('error') == -1 && router.url.indexOf('payment') == -1 && router.url.indexOf('confirmation') == -1" class="action-bar action-bar__bottom">
    <index-grid-column size="8" childHorizontalAlignment="left">
        <app-download-button></app-download-button>
    </index-grid-column>
    <index-grid-column size="4" childHorizontalAlignment="right">
      <index-button type="primary"
                    size="full"
                    *ngIf="this.showPayButton"
                    (click)="this.handlePayClick()"
                    class="mx-auto">{{ 'Pay' | transloco }}</index-button>
    </index-grid-column>
</index-grid>

<hr class="secondary-brand">
